import React from 'react';
import './App.css';
import { Link } from 'react-router-dom';

const Paper = () => (
	<>
		<div style={{ margin: 'auto', padding: '24px', maxWidth: 900, marginTop: 64 }}>
			<h1>The control-synthesis approach for making expressive and controllable neural music synthesizers</h1>

			<hr style={{ border: '2px solid black', width: '100%' }}></hr>

			<div
				style={{
					margin: 'auto',
					width: '100%',
					display: 'flex',
					justifyContent: 'space-evenly',
					flexDirection: 'column',
					fontSize: 24,
				}}
			>
				<Link style={{ marginTop: 24 }} to="/evaluation">
					➤ Evaluation
				</Link>

				<Link style={{ marginTop: 24 }} to="/controlflexibility">
					➤ Additional experiments concerning control flexibility
				</Link>
			</div>
		</div>
	</>
);

export default Paper;
